import Hls from 'hls.js';
import { useEffect, useRef } from 'react';
import { RemotionMainVideoProps, RemotionVideoProps, Video } from 'remotion';
import appLogger from '@/services/logger';

const HlsVideo: React.FC<RemotionVideoProps & RemotionMainVideoProps> = ({ src, ...props }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!src) {
      throw new Error('src is required');
    }

    const startFrom = 0;

    const hls = new Hls({
      startLevel: 4,
      maxBufferLength: 5,
      maxMaxBufferLength: 5
    });

    hls.on(Hls.Events.MANIFEST_PARSED, () => {
      hls.startLoad(startFrom);
    });

    hls.on(Hls.Events.ERROR, (_, data) => {
      if (data.fatal && data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR) {
        appLogger.error('M3U8 manifest load failed in Remotion HlsVideo', {
          url: src,
          error: data.details,
          status: data.response?.code
        });
      } else if (data.fatal && data.details === Hls.ErrorDetails.FRAG_LOAD_ERROR) {
        appLogger.error('M3U8 fragment load failed in Remotion HlsVideo', {
          url: src,
          error: data.details,
          fragUrl: data.frag?.url
        });
      } else if (data.fatal) {
        appLogger.error('HLS fatal error in Remotion HlsVideo', {
          url: src,
          error: data.details,
          type: data.type
        });
      }
    });

    hls.loadSource(src);
    hls.attachMedia(videoRef.current!);

    return () => {
      hls.destroy();
    };
  }, [src]);

  return <Video src={src} {...props} ref={videoRef} />;
};

export default HlsVideo;
